import type { RouteIdType } from './routeDefinitions';
import { RouteId } from './routeDefinitions';

const boardRoutes = new Set<string>([RouteId.BOARD, RouteId.BOARD_REFERRAL]);

export const isBoardRoute = (routeId: RouteIdType): boolean =>
  boardRoutes.has(routeId);
